import { render, staticRenderFns } from "./div-popu.vue?vue&type=template&id=52e0bdda&scoped=true"
import script from "./div-popu.vue?vue&type=script&lang=js"
export * from "./div-popu.vue?vue&type=script&lang=js"
import style0 from "./div-popu.vue?vue&type=style&index=0&id=52e0bdda&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e0bdda",
  null
  
)

export default component.exports